import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Benefits from "@/components/Benefits";
import Products from "@/components/Products";
import Process from "@/components/Process";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import FinalCTA from "@/components/FinalCTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-white">
      <Header />
      <Hero />
      <TrustBar />
      <Benefits />
      <Products />
      <Process />
      <Gallery />
      <Testimonials />
      <FinalCTA />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
